
document.addEventListener("toggle", function (e) {
  var item = e.target;
  if (item.tagName !== "DETAILS" || !item.classList.contains("product__accordion-item")) return;
  if (!item.open) return;
  var group = item.closest("product-accordion");
  if (!group) return;
  group.querySelectorAll("details.product__accordion-item[open]").forEach(function (other) {
    if (other !== item) other.open = false;
  });
}, true);

document.addEventListener("DOMContentLoaded", function () {
  var ProductInfoElement = customElements.get("product-info");
  if (!ProductInfoElement || !ProductInfoElement.prototype) return;
  ProductInfoElement.prototype.scrollToImage = function () { return; };
});

document.addEventListener("DOMContentLoaded", function () {
  if (typeof PhotoSwipeLightbox === "undefined" || typeof PhotoSwipe === "undefined") return;
  if (!document.querySelector(".photoswipe-wrapper a[data-pswp-src]")) return;

  document.querySelectorAll("a[data-pswp-src]").forEach(function (el) {
    el.removeAttribute("target");
    el.addEventListener("click", function (e) { e.preventDefault(); });
  });

  document.querySelectorAll(
    "a.product__gallery-toggle[data-pswp-type], a.product__gallery-toggle[data-pswp-html]"
  ).forEach(function (el) {
    if (el.hasAttribute("data-pswp-src")) return;
    el.removeAttribute("target");
  });
  var lightbox = new PhotoSwipeLightbox({
    gallery: ".photoswipe-wrapper",
    children: "a[data-pswp-src]",
    pswpModule: PhotoSwipe,
    bgOpacity: 1,
    showHideOpacity: true,
  });

  lightbox.on("uiRegister", function () {
    lightbox.pswp.ui.registerElement({
      name: "custom-nav",
      order: 9,
      isButton: false,
      appendTo: "wrapper",
      html: '<button class="pswp__custom-prev" type="button" aria-label="Previous"><svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"></polyline></svg></button>' +
            '<span class="pswp__custom-counter"></span>' +
            '<button class="pswp__custom-next" type="button" aria-label="Next"><svg viewBox="0 0 24 24"><polyline points="9 6 15 12 9 18"></polyline></svg></button>',
      onInit: function (el, pswp) {
        el.classList.add("pswp__custom-nav");
        var counter = el.querySelector(".pswp__custom-counter");
        var prevBtn = el.querySelector(".pswp__custom-prev");
        var nextBtn = el.querySelector(".pswp__custom-next");

        function updateCounter() {
          counter.textContent = (pswp.currIndex + 1) + " / " + pswp.getNumItems();
        }

        prevBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          pswp.prev();
        });
        nextBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          pswp.next();
        });

        pswp.on("change", updateCounter);
        updateCounter();
      }
    });
  });

  lightbox.init();
});

document.addEventListener("DOMContentLoaded", function () {
  var productWrap = document.querySelector("product-variant-selects");
  if (!productWrap) return;
  var colorFieldset = Array.from(productWrap.querySelectorAll("fieldset")).find(function (fs) {
    var legend = fs.querySelector("legend.form__label");
    return legend && legend.textContent.includes("Color");
  });
  if (!colorFieldset) return;

  var redirectMap = {
    "Chanel Hair Wig": "/products/chanel-hair-wig",
    "Fully Hand Tied": "/products/taylor-20-fully-hand-tied-human-hair-wig",
  };
  function goToMappedProduct(input) {
    if (!input) return;
    var value = (input.value || "").trim();
    var targetUrl = redirectMap[value];
    if (!targetUrl) return;
    var currentPath = window.location.pathname.replace(/\/+$/, "");
    var targetPath = targetUrl.replace(/^https?:\/\/[^/]+/i, "").replace(/\/+$/, "");
    if (currentPath === targetPath) return;
    window.location.href = targetUrl;
  }
  colorFieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
    var label = colorFieldset.querySelector('label[for="' + input.id + '"]');
    if (label) {
      label.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        goToMappedProduct(input);
      }, true);
    }
    input.addEventListener("change", function () { goToMappedProduct(input); });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  function updateNoneState() {
    document.querySelectorAll(".easify .po-select-root").forEach(function (root) {
      var valueEl = root.querySelector(".po-select-selectedValue");
      var button = root.querySelector(".po-select-button");
      if (!valueEl || !button) return;
      if (valueEl.textContent.trim().toLowerCase() === "none") {
        button.classList.add("po-is-none");
      } else {
        button.classList.remove("po-is-none");
      }
    });
  }
  updateNoneState();
  document.addEventListener("click", function () { setTimeout(updateNoneState, 80); });
  document.addEventListener("change", function () { setTimeout(updateNoneState, 80); });
});

var GL_REQUIRED_DROPDOWN_NAMES = ["properties[Lace Cut]", "properties[Cut The Lace]"];
var GL_REQUIRED_CHECKBOX_VALUES = [
  "I've read and agree to the Goldylost return policy",
  "I've read and agree to the return policy",
];

document.addEventListener("DOMContentLoaded", function () {
  var REQUIRED_DROPDOWN_NAMES = GL_REQUIRED_DROPDOWN_NAMES;
  var REQUIRED_CHECKBOX_VALUES = GL_REQUIRED_CHECKBOX_VALUES;

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function clearErrors() {
    document.querySelectorAll(".gl-required-error").forEach(function (el) { el.remove(); });
    document.querySelectorAll(".gl-field-error").forEach(function (el) { el.classList.remove("gl-field-error"); });
  }

  function showError(fieldEl) {
    var container = fieldEl.closest(".tpo_option-container") || fieldEl.parentElement;
    if (!container) return null;
    container.classList.add("gl-field-error");
    var msg = document.createElement("div");
    msg.className = "gl-required-error";
    msg.textContent = "This field is required.";
    container.appendChild(msg);
    return msg;
  }

  function validateDropdowns() {
    var inputs = document.querySelectorAll(".tpo_option-set-wrapper input.tpo_option-input.tpo_option-dropdown");
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (REQUIRED_DROPDOWN_NAMES.indexOf(input.name) === -1) continue;
      if (!isVisible(input)) continue;
      if (!input.value || !input.value.trim()) return showError(input);
    }
    return null;
  }

  function validateCheckboxes() {
    var boxes = document.querySelectorAll(".tpo_option-set-wrapper input.tpo-checkbox-button");
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (REQUIRED_CHECKBOX_VALUES.indexOf(box.value) === -1) continue;
      var label = box.closest("label") || box;
      if (!isVisible(label)) continue;
      if (!box.checked) return showError(label);
    }
    return null;
  }

  var submitBtn = document.querySelector('[id^="ProductSubmitButton-"]');
  if (!submitBtn) return;

  submitBtn.addEventListener("click", function (e) {
    clearErrors();
    var firstError = validateDropdowns() || validateCheckboxes();
    if (firstError) {
      e.preventDefault();
      e.stopImmediatePropagation();
      firstError.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, true);
});

(function () {
  var CONVERTED_ATTR = "data-price-converted";

  function getRate() {
    if (typeof Shopify === "undefined" || !Shopify.currency) return null;
    var rate = parseFloat(Shopify.currency.rate);
    return (rate && rate > 0) ? rate : null;
  }

  function convertPriceText(text) {
    var rate = getRate();
    if (!rate) return null;
    var match = text.match(/([\d]+[.,]\d{2})/);
    if (!match) return null;
    var num = parseFloat(match[1].replace(/,/g, "."));
    if (isNaN(num) || num === 0) return null;
    var converted = (num * rate).toFixed(2);
    return text.replace(match[1], converted);
  }

  var PRICE_SELECTORS = [
    '.gpo-group-addon-price',
    '.gpo-mobile-addon-price',
    '.gpo-app .addOn'
  ].join(", ");

  function convertAll() {
    var rate = getRate();
    if (!rate) return;
    document.querySelectorAll(PRICE_SELECTORS).forEach(function (el) {
      if (el.getAttribute(CONVERTED_ATTR)) return;
      var original = el.textContent.trim();
      if (!original) return;
      var converted = convertPriceText(original);
      if (converted && converted !== original) {
        el.textContent = converted;
        el.setAttribute(CONVERTED_ATTR, "1");
      }
    });
  }

  function init() {
    if (getRate()) {
      start();
    } else {
      var waitInterval = setInterval(function () {
        if (getRate()) {
          clearInterval(waitInterval);
          start();
        }
      }, 200);
      setTimeout(function () { clearInterval(waitInterval); }, 10000);
    }
  }

  function start() {
    convertAll();
    var observer = new MutationObserver(function () { convertAll(); });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener("change", function () { setTimeout(convertAll, 150); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

document.addEventListener("DOMContentLoaded", function () {
  var CUT_IDS = [
    "9664f285-56de-4238-ab68-32d9cbbb2f1a",
    "fd573eae-182e-466e-a8f4-7b144ff739ab",
  ];

  function replaceLabelText(optionId) {
    var optionRoot = document.querySelector('.easify [data-option-id="' + optionId + '"]');
    if (!optionRoot) return false;
    var labelEl = optionRoot.querySelector(".po-label-label");
    if (!labelEl) return false;
    if (labelEl.querySelector(".po-addon-price-animated")) return true;
    var suffixEl = optionRoot.querySelector('[class*="po-label-suffix"]');
    if (!suffixEl) return false;
    var priceText = suffixEl.textContent.trim();
    if (!priceText) return false;
    priceText = priceText.replace(/^\+?\s*from\s*/i, "").trim();
    labelEl.innerHTML = 'CUT <span class="po-addon-price-animated">(' + priceText + ')</span>';
    suffixEl.style.display = "none";
    optionRoot.querySelectorAll('.po-select-selectedPrice, .po-optionItemLabel-price').forEach(function (el) {
      el.style.display = "none";
    });
    return true;
  }

  function run() { CUT_IDS.forEach(replaceLabelText); }

  run();
  var cutObserver = new MutationObserver(function () {
    var allFound = CUT_IDS.every(replaceLabelText);
    if (allFound) cutObserver.disconnect();
  });
  cutObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener("change", function () { setTimeout(run, 100); });
});

(function () {
  var originalScrollIntoView = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function (options) {
    if (
      this instanceof HTMLElement &&
      this.matches(".main-product__media [data-media-id], .product__media [data-media-id], .swiper-slide[data-media-id]") &&
      this.closest("product-info") &&
      options && typeof options === "object" && options.behavior === "smooth"
    ) {
      return;
    }
    return originalScrollIntoView.apply(this, arguments);
  };
})();

function addCapSizeAsterisk() {

}

function addGenericAsterisks() {
  document.querySelectorAll(".tpo_option-set-wrapper input.tpo_option-input.tpo_option-dropdown").forEach(function (input) {
    if (GL_REQUIRED_DROPDOWN_NAMES.indexOf(input.name) === -1) return;
    var container = input.closest(".tpo_option-container");
    var label = container && container.querySelector(".tpo_option-label-container > .form__label");
    if (!label || label.querySelector(".required-asterisk")) return;
    var star = document.createElement("span");
    star.className = "required-asterisk";
    star.textContent = " *";
    label.appendChild(star);
  });

  document.querySelectorAll(".tpo_option-set-wrapper input.tpo-checkbox-button").forEach(function (box) {
    if (GL_REQUIRED_CHECKBOX_VALUES.indexOf(box.value) === -1) return;
    var label = box.closest("label");
    var textEl = label && label.querySelector(".tpo_option_type_label");
    if (!textEl || textEl.querySelector(".required-asterisk")) return;
    var star = document.createElement("span");
    star.className = "required-asterisk";
    star.textContent = " *";
    textEl.appendChild(star);
  });
}

function linkifyReturnPolicy(label, url) {
  if (label.querySelector("a.gl-return-policy-link")) return;
  var walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT, null);
  var target = null, node;
  while ((node = walker.nextNode())) {
    if (/return\s+policy/i.test(node.nodeValue)) { target = node; break; }
  }
  if (!target) return;
  var val = target.nodeValue;
  var m = val.match(/return\s+policy/i);
  var frag = document.createDocumentFragment();
  var NBSP = String.fromCharCode(160);
  var before = val.slice(0, m.index).replace(/\s+$/, NBSP);
  var after = val.slice(m.index + m[0].length).replace(/^\s+/, NBSP);
  if (before) frag.appendChild(document.createTextNode(before));
  var a = document.createElement("a");
  a.className = "gl-return-policy-link";
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  a.textContent = val.slice(m.index, m.index + m[0].length);
  a.addEventListener("click", function (e) { e.stopPropagation(); });
  frag.appendChild(a);
  if (after) frag.appendChild(document.createTextNode(after));
  target.parentNode.replaceChild(frag, target);
}

function setupReturnPolicyCheckbox() {
  document.querySelectorAll(".po-label-label, .po-optionItemLabel-label").forEach(function (label) {
    var text = label.textContent.replace(/\s+/g, " ").trim().toUpperCase();
    if (text.indexOf("RETURN POLICY") === -1) return;
    var scope = label.closest(".po-optionItemLabel-mainRow") || label.closest(".po-checkboxOption-option") || label.closest(".po-option-root") || label.parentElement;
    var box = scope && scope.querySelector(".po-checkboxOption-checkbox");
    if (box) box.classList.add("gl-return-agree");
    linkifyReturnPolicy(label, "/pages/returns-policy");
  });
}

function addRequiredAsterisks() {
  addCapSizeAsterisk();
  addGenericAsterisks();
}

function wrapEasifyAddonPrices() {
  document.querySelectorAll(".easify .po-label-label").forEach(function (label) {
    if (label.querySelector(".po-addon-price-animated")) return;
    var text = label.textContent.trim();
    var match = text.match(/^(.*?)(\s*\((?:A\$|\$|£|€).+?\))$/);
    if (!match) return;
    label.innerHTML = match[1].trim() + ' <span class="po-addon-price-animated">' + match[2].trim() + "</span>";
  });
}

function cleanSuffixes() {
  document.querySelectorAll('.easify [class*="po-label-label"], .easify [class*="po-label-root"] label').forEach(function (label) {
    label.childNodes.forEach(function (node) {
      if (node.nodeType !== 1) return;
      var txt = (node.textContent || "").trim();
      if (!txt || !/\+from/i.test(txt)) return;
      txt = txt.replace(/\(\s*\+from\s*\((.*?)\)\s*\)/i, "($1)");
      txt = txt.replace(/\(\s*\+from\s*(.*?)\s*\)/i, "($1)");
      node.textContent = txt;
    });
  });
}

function bindCapSizeListeners() {
  var capSizeFound = false;
  document.querySelectorAll("product-variant-selects fieldset").forEach(function (fs) {
    var legend = fs.querySelector("legend.form__label");
    if (!legend || !legend.textContent.includes("Cap Size")) return;
    capSizeFound = true;
    var hasChecked = false;
    fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (input.checked) hasChecked = true;
      if (input._capSizeBound) return;
      input._capSizeBound = true;
      input.addEventListener("change", function () {
        document.body.classList.add("cap-size-selected");
        updateInventoryNoticeInstant(input);
      });
    });
    if (hasChecked) document.body.classList.add("cap-size-selected");
  });

  if (!capSizeFound) {
    document.body.classList.add("cap-size-selected");
  }
}

function updateInventoryNoticeInstant(selectedInput) {
  var notice = document.querySelector("[data-inventory-notice]");
  if (!notice) return;

  var qty = parseInt(selectedInput.getAttribute("data-variant-quantity") || "0", 10);
  var threshold = parseInt(notice.getAttribute("data-inventory-threshold") || "5", 10);
  var timerSvg = '<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8H13ZM12 12H11C11 12.2652 11.1054 12.5196 11.2929 12.7071L12 12ZM13.7929 15.2071C14.1834 15.5976 14.8166 15.5976 15.2071 15.2071C15.5976 14.8166 15.5976 14.1834 15.2071 13.7929L13.7929 15.2071ZM1.29289 4.54289C0.902369 4.93342 0.902369 5.56658 1.29289 5.95711C1.68342 6.34763 2.31658 6.34763 2.70711 5.95711L1.29289 4.54289ZM5.70711 2.95711C6.09763 2.56658 6.09763 1.93342 5.70711 1.54289C5.31658 1.15237 4.68342 1.15237 4.29289 1.54289L5.70711 2.95711ZM21.2929 5.95711C21.6834 6.34763 22.3166 6.34763 22.7071 5.95711C23.0976 5.56658 23.0976 4.93342 22.7071 4.54289L21.2929 5.95711ZM19.7071 1.54289C19.3166 1.15237 18.6834 1.15237 18.2929 1.54289C17.9024 1.93342 17.9024 2.56658 18.2929 2.95711L19.7071 1.54289ZM20 12C20 16.4183 16.4183 20 12 20V22C17.5228 22 22 17.5228 22 12H20ZM12 20C7.58172 20 4 16.4183 4 12H2C2 17.5228 6.47715 22 12 22V20ZM4 12C4 7.58172 7.58172 4 12 4V2C6.47715 2 2 6.47715 2 12H4ZM12 4C16.4183 4 20 7.58172 20 12H22C22 6.47715 17.5228 2 12 2V4ZM11 8V12H13V8H11ZM11.2929 12.7071L13.7929 15.2071L15.2071 13.7929L12.7071 11.2929L11.2929 12.7071ZM2.70711 5.95711L5.70711 2.95711L4.29289 1.54289L1.29289 4.54289L2.70711 5.95711ZM22.7071 4.54289L19.7071 1.54289L18.2929 2.95711L21.2929 5.95711L22.7071 4.54289Z" fill="currentColor"/></svg>';

  var newState = qty <= 0 ? "oos" : qty <= threshold ? "low" : "instock";
  var prevState = notice.getAttribute("data-inventory-state") || "";

  notice.setAttribute("data-inventory-quantity", qty);
  notice.setAttribute("data-inventory-state", newState);

  if (newState === "oos") {
    if (prevState !== "oos") {
      notice.innerHTML = timerSvg +
        '<span class="inventory-preorder-copy">' +
          '<span class="inventory-preorder-title">Available for pre-order</span>' +
          '<span class="inventory-preorder-detail">' +
            '<span>Estimated to ship in 10–12 weeks</span>' +
            '<a href="#" class="preorder-link">How pre-orders work</a>' +
          '</span>' +
        '</span>';
    }
    notice.classList.remove("hidden");
  } else if (newState === "low") {
    var lowHtml = '<span class="gl-stockbar"><span class="gl-stockbar__row"><span>Only ' + qty + ' left</span> <small>Low stock</small></span>' +
      '<span class="gl-stockbar__track" aria-hidden="true"><i style="width:' + Math.min(qty, 10) * 8 + '%"></i></span></span>';
    if (notice.innerHTML !== lowHtml) {
      notice.innerHTML = lowHtml;
    }
    notice.classList.remove("hidden");
  } else {
    notice.classList.add("hidden");
  }
}

function syncPreorderButtonLabel() {
  var notice = document.querySelector(".product__inventory-notice");
  var state = notice ? notice.getAttribute("data-inventory-state") : null;
  if (!state) return;
  var PRE = "Pre-order now";
  document.querySelectorAll('[id^="ProductSubmitButton-"]').forEach(function (btn) {
    if (btn.disabled) return;
    var span = btn.querySelector("span");
    if (!span) return;
    if (state === "oos") {
      if (span.textContent.trim() !== PRE) span.textContent = PRE;
    } else if (span.textContent.trim() === PRE) {
      span.textContent = "Add to cart";
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {

  cleanSuffixes();
  addRequiredAsterisks();
  wrapEasifyAddonPrices();
  setupReturnPolicyCheckbox();
  bindCapSizeListeners();

  var debounceTimer = null;

  function runAllEasifyTasks() {
    cleanSuffixes();
    addRequiredAsterisks();
    wrapEasifyAddonPrices();
    setupReturnPolicyCheckbox();
    bindCapSizeListeners();
    restoreInventoryNotice();
    syncPreorderButtonLabel();
  }

  var savedNoticeHTML = "";
  var savedNoticeState = "";
  var savedNoticeHidden = true;

  function restoreInventoryNotice() {
    if (!savedNoticeState) return;
    var notice = document.querySelector("[data-inventory-notice]");
    if (!notice) return;
    if (!notice.getAttribute("data-inventory-state") && savedNoticeHTML) {
      notice.innerHTML = savedNoticeHTML;
      notice.setAttribute("data-inventory-state", savedNoticeState);
      if (savedNoticeHidden) {
        notice.classList.add("hidden");
      } else {
        notice.classList.remove("hidden");
      }
    }
  }

  var origUpdate = window.updateInventoryNoticeInstant;
  if (typeof origUpdate === "function") {
    window.updateInventoryNoticeInstant = function (input) {
      origUpdate(input);
      var notice = document.querySelector("[data-inventory-notice]");
      if (notice && notice.getAttribute("data-inventory-state")) {
        savedNoticeHTML = notice.innerHTML;
        savedNoticeState = notice.getAttribute("data-inventory-state") || "";
        savedNoticeHidden = notice.classList.contains("hidden");
      }
    };
  }

  var productInfo = document.querySelector("[id^='ProductInfo-']");
  if (productInfo) {
    new MutationObserver(function () {
      restoreInventoryNotice();
      syncPreorderButtonLabel();
    }).observe(productInfo, { childList: true, subtree: true });
  }

  new MutationObserver(function () {
    if (debounceTimer) return;
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      runAllEasifyTasks();
    }, 80);
  }).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
});

document.addEventListener("DOMContentLoaded", function () {
  function pairProductTextBlocks() {
    document.querySelectorAll(".product__content").forEach(function (container) {
      var texts = container.querySelectorAll(":scope > .product__text");
      var i = 0;
      while (i < texts.length - 1) {
        var current = texts[i];
        var next = texts[i + 1];
        if (
          current.nextElementSibling === next &&
          !current.parentNode.classList.contains("product__text-row")
        ) {
          var wrapper = document.createElement("div");
          wrapper.className = "product__text-row product__block";
          current.parentNode.insertBefore(wrapper, current);
          wrapper.appendChild(current);
          wrapper.appendChild(next);
          i += 2;
        } else {
          i += 1;
        }
      }
    });
  }
  pairProductTextBlocks();
});

(function () {
  function setupVideos() {
    document.querySelectorAll(".main-product__media video").forEach(function (video) {
      if (video.closest(".pswp")) return;
      if (video.dataset.glPdpVideoReady) return;
      video.dataset.glPdpVideoReady = "1";

      try { video.removeAttribute("controls"); video.controls = false; } catch (_) {}

      var wrap = video.parentElement;
      if (!wrap) return;
      if (window.getComputedStyle(wrap).position === "static") {
        wrap.style.position = "relative";
      }

      function btn(cls, label, innerSvg) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "gl-pdp-video " + cls;
        b.setAttribute("aria-label", label);
        b.innerHTML = innerSvg;
        return b;
      }

      var ICON_PLAY  = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
      var ICON_PAUSE = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6 4h4v16H6zM14 4h4v16h-4z"/></svg>';
      var ICON_FULL  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3"/></svg>';
      var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

      video.muted = true;

      var playBtn  = btn("gl-pdp-video__play", "Play or pause", ICON_PLAY);
      var fullBtn  = btn("gl-pdp-video__full", "Open fullscreen", ICON_FULL);
      var closeBtn = btn("gl-pdp-video__close", "Close fullscreen", ICON_CLOSE);

      function sync() {
        playBtn.innerHTML = video.paused || video.ended ? ICON_PLAY : ICON_PAUSE;
        playBtn.classList.toggle("is-playing", !video.paused && !video.ended);
      }

      function togglePlay(e) {
        if (e) { e.stopPropagation(); e.preventDefault(); }
        if (video.paused || video.ended) { video.play().catch(function () {}); }
        else { video.pause(); }
      }
      playBtn.addEventListener("click", togglePlay);

      video.style.cursor = "pointer";
      video.addEventListener("click", togglePlay);

      var fsOverlay = null;
      function enterSimulatedFullscreen() {
        if (fsOverlay) return;
        var originalParent = video.parentNode;
        var originalNextSibling = video.nextSibling;
        var originalStyle = video.getAttribute("style");

        fsOverlay = document.createElement("div");
        fsOverlay.className = "gl-pdp-video-fs";
        Object.assign(fsOverlay.style, {
          position: "fixed",
          inset: "0",
          background: "#fff",
          zIndex: "2147483647",
        });

        fsOverlay.appendChild(video);
        Object.assign(video.style, {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
          height: "100%",
          maxWidth: "100vw",
          maxHeight: "100vh",
          objectFit: "contain",
          background: "#fff",
        });

        function styleBtn(b, pos) {
          Object.assign(b.style, Object.assign({
            position: "absolute",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            padding: "0",
            zIndex: "10",
            border: "none",
          }, pos));
        }

        var fsClose = btn("gl-pdp-video-fs__close", "Close fullscreen", ICON_CLOSE);
        styleBtn(fsClose, {
          top: "18px", right: "18px",
          width: "56px", height: "56px",
          background: "#ffffff",
          border: "2px solid #000000",
          color: "#000000",
          boxShadow: "0 4px 14px rgba(0,0,0,0.35)",
        });
        fsClose.addEventListener("click", function (ev) { ev.stopPropagation(); exitSimulatedFullscreen(); });

        var fsPlay = btn("gl-pdp-video-fs__play", "Play / pause", video.paused ? ICON_PLAY : ICON_PAUSE);
        styleBtn(fsPlay, {
          top: "50%", left: "50%",
          transform: "translate(-50%, -50%)",
          width: "72px", height: "72px",
          background: "rgba(0,0,0,0.55)",
          color: "#ffffff",
          opacity: video.paused ? "1" : "0",
          pointerEvents: video.paused ? "auto" : "none",
          transition: "opacity 0.2s ease",
        });
        fsPlay.addEventListener("click", function (ev) {
          ev.stopPropagation();
          togglePlay();
        });

        function fsSync() {
          var paused = video.paused || video.ended;
          fsPlay.innerHTML = paused ? ICON_PLAY : ICON_PAUSE;
          fsPlay.style.opacity = paused ? "1" : "0";
          fsPlay.style.pointerEvents = paused ? "auto" : "none";
        }
        video.addEventListener("play", fsSync);
        video.addEventListener("pause", fsSync);
        video.addEventListener("ended", fsSync);

        fsOverlay.appendChild(fsClose);
        fsOverlay.appendChild(fsPlay);

        function escHandler(ev) {
          if (ev.key === "Escape") exitSimulatedFullscreen();
        }
        document.addEventListener("keydown", escHandler);

        fsOverlay._restore = function () {
          video.removeEventListener("play", fsSync);
          video.removeEventListener("pause", fsSync);
          video.removeEventListener("ended", fsSync);
          video.removeEventListener("volumechange", fsSync);
          document.removeEventListener("keydown", escHandler);
          if (originalParent) originalParent.insertBefore(video, originalNextSibling);
          if (originalStyle !== null) video.setAttribute("style", originalStyle);
          else video.removeAttribute("style");
          fsOverlay.remove();
          fsOverlay = null;
          document.body.style.overflow = "";
        };

        document.body.appendChild(fsOverlay);
        document.body.style.overflow = "hidden";
      }
      function exitSimulatedFullscreen() {
        if (fsOverlay && fsOverlay._restore) fsOverlay._restore();
      }

      fullBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        enterSimulatedFullscreen();
      });

      video.addEventListener("play", sync);
      video.addEventListener("pause", sync);
      video.addEventListener("ended", sync);

      wrap.appendChild(playBtn);
      wrap.appendChild(fullBtn);
      sync();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupVideos);
  } else {
    setupVideos();
  }

  var t;
  new MutationObserver(function () {
    if (t) return;
    t = setTimeout(function () { t = null; setupVideos(); }, 120);
  }).observe(document.body, { childList: true, subtree: true });
})();

(function () {
  var FIELD_NAME = "properties[Hair Cut]";

  function cutInputs() {
    return document.querySelectorAll(
      '.tpo_option-set-wrapper .tpo_option-input.tpo_option-dropdown[name="' + FIELD_NAME + '"]'
    );
  }

  function refreshCutDisplay(input) {
    var container = input.closest(".tpo_option-container");
    if (!container) return;
    var overlay = container.querySelector(".gl-cut-name-overlay");
    if (!overlay) {
      overlay = document.createElement("span");
      overlay.className = "gl-cut-name-overlay";
      overlay.setAttribute("aria-hidden", "true");
      input.insertAdjacentElement("afterend", overlay);
    }
    var priceEl = container.querySelector(".form__label > span");
    var value = input.value || "";
    var match = value.match(/^(.+?)\s*\[\s*([^\]]*?)\s*\]\s*$/);
    if (match) {
      overlay.textContent = match[1].trim();
      if (priceEl) priceEl.textContent = match[2] ? "(" + match[2].trim() + ")" : "";
    } else {
      overlay.textContent = value.trim();
      if (priceEl) priceEl.textContent = "";
    }
  }

  document.addEventListener("click", function (e) {
    if (!e.target.closest) return;
    var item = e.target.closest(".tpo_option-type-selection");
    if (!item) return;
    var container = item.closest(".tpo_option-container");
    if (!container) return;
    var input = container.querySelector(
      '.tpo_option-input.tpo_option-dropdown[name="' + FIELD_NAME + '"]'
    );
    if (!input) return;
    setTimeout(function () { refreshCutDisplay(input); }, 0);
  }, true);

  function initCutDisplay() {
    var inputs = cutInputs();
    if (!inputs.length) return false;
    inputs.forEach(refreshCutDisplay);
    return true;
  }

  if (!initCutDisplay()) {
    var observer = new MutationObserver(function () {
      if (initCutDisplay()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
